import * as React from 'react';

import { HStack, Text } from '@rbilabs/universal-components';
import isNumber from 'lodash/isNumber';
import { useIntl } from 'react-intl';

import { ISanityImage } from '@rbi-ctg/menu';
import Picture from 'components/picture';
import { useQuestContext } from 'components/quests/loyalty-quest';
import { isIncentiveRedeemed, isQuestCompleted } from 'components/quests/loyalty-quest/utils';
import { IImageFragment } from 'generated/sanity-graphql';

import { QuestPointsPicture } from './quest-points-picture';

export const QuestPointsIncentive = ({
  description,
  image,
}: {
  description: string;
  image?: ISanityImage | IImageFragment | null;
}) => {
  const { quest } = useQuestContext();
  const { formatMessage } = useIntl();

  return (
    <HStack space="$4" justifyContent="space-between">
      {!image && isNumber(quest.bonusPoints) && (
        <QuestPointsPicture bonusPoints={quest.bonusPoints} />
      )}
      {image && <Picture width="$16" height="$16" image={image} alt={description} />}
      <Text flexShrink={1} color="white">
        {isQuestCompleted(quest.status) && isIncentiveRedeemed(quest.lastCompletion)
          ? formatMessage(
              { id: 'bonusPointsIncentiveDescription' },
              {
                points: quest.bonusPoints,
              }
            )
          : description}
      </Text>
    </HStack>
  );
};
